import Tooltip from 'components/Tooltip';
import React, { Component, createRef, Fragment, SyntheticEvent } from 'react';
import { openModalTooltip } from 'actions/modalTooltip';
import classnames from 'classnames';
import { ImageProps } from 'components/Image/props';
import Interactive, { ClickType, State as ReactInteractiveState } from 'react-interactive';
import { connect } from 'react-redux';
import getImagePath from 'utils/getImagePath';

type Props = ImageProps & { dispatch: Function };

type State = {
  isModalOpen: boolean,
  isTooltipActive: boolean,
};

export class ImageComponent extends Component<Props, State> {
  element = createRef<HTMLImageElement>();

  state = {
    isModalOpen: false,
    isTooltipActive: false,
  };

  handleClick = (evt: SyntheticEvent, clickType: ClickType) => {
    const {
      alwaysTriggerOnClick,
      onClick = () => null,
    } = this.props;

    if (alwaysTriggerOnClick) {
      return onClick(evt);
    }

    // If we received a mouse click, then just run the 'onClick' handler that
    // we were given
    if (clickType === 'mouseClick') {
      return onClick(evt);
    }
    // Otherwise, this was a tap event (or similar) that requires us to show
    // the info tooltip (with action buttons)
    return this.showModal();
  };

  handleStateChange = ({ nextState }: { event: SyntheticEvent, nextState: ReactInteractiveState }) => {
    const isHoverActive = /hover/.test(nextState.iState);
    this.setState({ isTooltipActive: isHoverActive });
  };

  showModal = () => {
    const {
      dispatch,
      icon,
      tooltipData,
      type,
    } = this.props;
    const imagePath = getImagePath({ icon, type });
    dispatch(openModalTooltip({ ...tooltipData, imagePath }));
  };

  render() {
    const {
      className,
      defaultCursor,
      icon,
      width,
      height,
      alt,
      type,
      style,
      tooltipData,
      tooltipPos,
      tooltipTimeout,
    } = this.props;

    const { isTooltipActive } = this.state;

    return (
      <Fragment>
        <Interactive
          as="div"
          aria-label={alt}
          onClick={this.handleClick}
          onStateChange={this.handleStateChange}
        >
          <img
            alt={alt}
            aria-label={alt}
            className={classnames(
              defaultCursor && 'cursor-default',
              className,
            )}
            height={height}
            ref={this.element}
            src={getImagePath({ icon, type })}
            style={style}
            width={width}
          />
        </Interactive>

        {tooltipData && this.element.current && (
          <Tooltip
            data={tooltipData}
            active={isTooltipActive}
            parent={this.element.current}
            tooltipPos={tooltipPos}
            tooltipTimeout={tooltipTimeout}
          />
        )}
      </Fragment>
    );
  }
}

export default connect()(ImageComponent);
